import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { PopulationFragment } from "@shared/data/fragments/PopulationFragment/PopulationFragment.fragment";
import { POPULATION_FRAGMENT } from "@shared/data/fragments/PopulationFragment/PopulationFragment.fragment";

const Populations_Shared_Query = gql`
  query Populations_Shared_Query($input: [PopulationSort!]) {
    viewer {
      populations(sort: $input) {
        ...PopulationFragment
      }
    }
  }
  ${POPULATION_FRAGMENT}
`;

interface PopulationData {
  viewer: {
    populations: PopulationFragment[];
  };
}

interface PopulationSort {
  field: string;
  direction: string;
}

interface Variables {
  input?: [PopulationSort];
}

const usePopulationQuery = (options?: QueryHookOptions<PopulationData, Variables>) =>
  useQuery(Populations_Shared_Query, options);

export type { PopulationData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { usePopulationQuery, Populations_Shared_Query };
